import { CompanyHomeThemeSizeConfig } from './types';

const medium: CompanyHomeThemeSizeConfig = {
  companyHome: {},
};

export default medium;
